module.exports = __webpack_public_path__ + "static/media/Grandma.f5e5d7bd.jpg";